// เรื่องใบอนุญาตของแต่ละรายการ: เทียบใบข้อมูลสินค้ากับกฎพิกัด + สิ่งที่เคยจดไว้ — ฟังก์ชันล้วน ไม่แตะฐาน
//   user (2 พ.ย. 2569): "เวลาเอา invoice เข้า แอพแจ้งได้เลยว่ารายการไหนต้องขอ สมอ., เกษตร หรืออื่นๆ อ้างอิงจากที่เคยต้องขอก็ได้"
//
// ⚠ กติกาที่ห้ามพัง:
//   ① ระบบไม่บอกว่า "ไม่ต้องขอ" เอง — ไม่เจอ = quiet (ยังไม่มีข้อมูล) · กฎพิกัด 160 แถวมาจากการนำเข้าทะเบียนที่ไม่เคยไล่มาตรการ
//      เคยมีจริง: 3924.10.99 กับ 9617.00.10 เป็น [] จน NSW เตือนกลางตู้ SP-261015 แล้วรอ 3-5 วัน
//   ② NSW เตือนตามพิกัด ไม่สนว่าของทำจากอะไร (TC-036 เป็นผ้าโพลีเอสเตอร์ แต่พิกัดติดเกษตร) ⇒ พิกัดตรง = must เสมอ ผลอาจเป็น "ไม่เข้าข่าย" ก็ได้
//   ③ ช่องพิกัดมีข้อความต่อท้าย ('76151090 20%tisi') ตัดที่ตัวแรกที่ไม่ใช่เลข/จุด/ขีด — ลอกเลขทั้งหมดจะได้ 7615109020 แล้วไม่ตรงอะไรเลย

export const PERMIT_AGENCY = {
  tisi:      { chip: 'สมอ.', name: 'สำนักงานมาตรฐานผลิตภัณฑ์อุตสาหกรรม', order: 1,
    advice: 'ผลอาจเป็นใบอนุญาต หรือหนังสือว่าไม่เข้าข่าย · ผลรอบก่อนใช้กับ invoice ใหม่ไม่ได้ · ครั้งก่อนรู้ช้าแล้วรอเอกสาร 3-5 วัน จึงควรเริ่มตั้งแต่ได้ invoice · เราขอเองได้เร็วกว่า ฝากแจ้ง Yusen ว่าเราจะขอเอง',
    link: { href: 'https://nsw.tisi.go.th/trader/tisi01q010', text: 'ส่งคำขอ สมอ. →' } },
  doa:       { chip: 'เกษตร', name: 'กรมวิชาการเกษตร', order: 2,
    advice: 'ใบ Phyto มาจากซัพพลายเออร์และออกย้อนหลังไม่ได้ ฝากช่วยถามก่อนของออก · พ.ก.5 เป็นการแจ้งนำเข้าฝั่งไทย ฝากช่วยถามชิปปิ้งทุกรอบว่าต้องใช้เอกสารใด · ถ้าสินค้าไม่ได้ทำจากไม้หรือพืช พิกัดนี้ก็ยังถูกเตือนได้' },
  dnp:       { chip: 'อุทยานฯ', name: 'กรมอุทยานแห่งชาติ สัตว์ป่า และพันธุ์พืช', order: 3,
    advice: 'ฝากช่วยถามชิปปิ้งก่อนของออกว่ารอบนี้ต้องยื่นเอกสารใด' },
  fisheries: { chip: 'ประมง', name: 'กรมประมง', order: 4 },
  fda:       { chip: 'อย.', name: 'สำนักงานคณะกรรมการอาหารและยา', order: 5 },
  forest:    { chip: 'ป่าไม้', name: 'กรมป่าไม้', order: 6 },
  excise:    { chip: 'สรรพสามิต', name: 'กรมสรรพสามิต', order: 7 },
  origin:    { chip: 'เอกสารต้นทาง', name: 'เอกสารจากประเทศต้นทาง', order: 8 },
  other:     { chip: 'อื่น ๆ', name: 'หน่วยงานอื่นที่เกี่ยวข้อง', order: 9 },
};

// การ์ดเอกสารในตู้ที่นับเป็นเรื่องของหน่วยงานนี้ (document_requirement.req_type)
export const AGENCY_REQ_TYPES = {
  tisi: ['permit_tisi'], doa: ['phytosanitary', 'fumigation'], dnp: ['import_license_other'],
  fisheries: ['import_license_other'], fda: ['permit_fda'], forest: ['permit_forest'],
  excise: ['permit_excise'], origin: ['import_license_other'], other: ['import_license_other'],
};

const REQ_AGENCY = {
  permit_tisi: 'tisi', phytosanitary: 'doa', fumigation: 'doa',
  permit_forest: 'forest', permit_fda: 'fda', permit_excise: 'excise',
};

// พิกัดที่มีเหตุให้สงสัย แต่ยังไม่เคยถูกเรียกในรายการของบริษัท ⇒ ฝากเช็ค ไม่ใส่ในกฎพิกัด
//   (ใส่ใน hs_rule.measures = compute_requirements สร้างการ์ดบังคับให้ทันที ซึ่งเกินกว่าหลักฐาน)
//   ที่มา: ฐาน HS ของ สมอ. www3.tisi.go.th/hscode · ประกาศศุลกากร 224/2564 — ค้น 2 พ.ย. 2569
const PAPER = 'ฐาน HS ของ สมอ. ผูกพิกัดนี้กับ มอก. 3438-2565 (กระดาษสัมผัสอาหารสำหรับปรุงอาหารด้วยความร้อน มีผล 22 มิ.ย. 2569) และ มอก. 2948-2562 (กระดาษสัมผัสอาหาร มีผล 22 มิ.ย. 2570)';
export const CHECK_HS = {
  '48191000000': { agency: 'tisi', why: PAPER },
  '48239099090': { agency: 'tisi', why: PAPER },
  '84145941090': { agency: 'tisi', why: 'ฐาน HS ของ สมอ. ผูกพิกัดนี้กับ มอก. 934-2558 (พัดลมไฟฟ้ากระแสสลับ)' },
  '85044090090': { agency: 'tisi', why: 'ฐาน HS ของ สมอ. ผูกพิกัดนี้กับ มอก. 1955-2551 (สัญญาณรบกวนวิทยุ) และ มอก. 2603 เล่ม 2-2556 (ตัวผกผันกำลังไฟฟ้า)' },
  '44219190000': { agency: 'doa', why: 'พิกัดนี้อยู่ในประกาศศุลกากร 224/2564 ของกรมวิชาการเกษตร' },
  // เก้าอี้โครงไม้: เอกสารต้นทาง ไม่ใช่เกษตร (รายการ Phyto ของ Snow Peak 2567 ไม่มี LV-085/LV-091)
  '94016990000': { agency: 'origin', why: 'พิกัด 9401.69 คือเก้าอี้โครงไม้ · ประกาศ พณ. 2566 ที่กฎ 9403.60 อ้างถึงรวมเก้าอี้ไม้ 9401 ต้องมี C/O หรือหลักฐานอนุญาตส่งออก' },
};

// รุ่นที่รายการ LPI ของบริษัทจดไว้ใต้ สมอ. แต่ใบข้อมูลสินค้าตอนนี้ใช้พิกัดอื่น (เทียบรหัสตรงตัว ห้าม prefix: CS2-500 ไม่ใช่ CS-250)
const LPI_SPOON = { agency: 'tisi', why: 'รุ่นเดียวกันนี้อยู่ในรายการ LPI ของบริษัทใต้ สมอ. ด้วยพิกัด 8215.20.00.000' };
const LPI_LAMP = { agency: 'tisi', why: 'รุ่นเดียวกันนี้อยู่ในรายการ LPI ของบริษัทใต้ สมอ. ด้วยพิกัด 9405.42.90.000' };
export const CHECK_SKU = {
  'SCT004': LPI_SPOON, 'SCT004BL': LPI_SPOON, 'SCT004GR': LPI_SPOON, 'SCT004PR': LPI_SPOON, 'SCT004RE': LPI_SPOON,
  'CLC401BK(AK1)': LPI_LAMP, 'CLC401DG(AK1)': LPI_LAMP, 'CLC401RD(AK1)': LPI_LAMP, 'CLL781MG(AK1)': LPI_LAMP,
};

const skuKey = (s) => (s || '').normalize('NFC').trim().toUpperCase().replace(/[\s._-]+/g, '');

// ตัดข้อความต่อท้าย (อัตราอากร/โน้ต) ออกก่อนค่อยเก็บตัวเลข
export function hsDigits(raw) {
  const s = (raw ?? '').toString().normalize('NFKC').trim();
  const m = s.match(/^[0-9.\-]+/);
  return m ? m[0].replace(/\D/g, '') : '';
}

export function formatHs(d) {
  if (d.length === 11) return `${d.slice(0, 4)}.${d.slice(4, 6)}.${d.slice(6, 8)}.${d.slice(8)}`;
  if (d.length === 8) return `${d.slice(0, 4)}.${d.slice(4, 6)}.${d.slice(6)}`;
  return d;
}

function measureList(rule) {
  let ms = rule?.measures ?? [];
  if (typeof ms === 'string') { try { ms = JSON.parse(ms); } catch { ms = []; } }
  return Array.isArray(ms) ? ms.filter(m => m && typeof m === 'object') : [];
}

// measure.agency ก่อน (string หรือ array) ไม่มีค่อยเดาจากชนิดเอกสาร
export function measureAgencies(m) {
  const own = (Array.isArray(m?.agency) ? m.agency : [m?.agency])
    .filter(a => typeof a === 'string' && Object.hasOwn(PERMIT_AGENCY, a));
  if (own.length) return own;
  if (Object.hasOwn(REQ_AGENCY, m?.req_type ?? '')) return [REQ_AGENCY[m.req_type]];
  if (m?.side === 'export') return ['origin'];
  if (/อุทยาน/.test(m?.note ?? '')) return ['dnp'];
  return ['other'];
}

export function buildPermitIndex(rules) {
  const by11 = new Map(), by8 = new Map();
  for (const r of rules ?? []) {
    const d = hsDigits(r?.hs_code);
    if (d.length !== 11) continue;
    by11.set(d, r);
    const k = d.slice(0, 8);
    if (!by8.has(k)) by8.set(k, []);
    by8.get(k).push(r);
  }
  return { by11, by8, size: by11.size };
}

// หมายเหตุที่คนจดไว้ในทะเบียนเดิม (มาจากการนำเข้า C76 — อยู่ใน name_en / hs_code)
//   ⚠ "สมอบก" (สมอบกปักเต็นท์) กับ "มีดพก" ต้องไม่ติด — จับเฉพาะรูปที่มี ** หรือ "ติด สมอ"
const NOTE_DOA = /\*+\s*(?:ขอ\s*)?พ\.?\s*ก\.?\s*5/;
const NOTE_TISI = /(?:\*+\s*)?ติด\s*สมอ(?!บก)/;
const NOTE_HS_TISI = /tisi/i;

// คำบอกว่าทำจากไม้/ไผ่ ⇒ แค่ฝากเช็ค (firewood/ไม้แขวน/ไม้เท้า ไม่นับ)
const WOOD_EN = /\b(?:wood|wooden|bamboo|teak|hinoki|cedar|walnut)\b/i;
const WOOD_TH = /ไม้(?!แขวน|เท้า|กอล์ฟ|กวาด|ถู|จิ้ม|ขีด|เสียบ)|ไผ่|วอลนัท/;
function woodWord(...texts) {
  for (const t of texts) {
    if (!t) continue;
    // ผลไม้/มีดตัดไม้ ไม่ได้แปลว่าตัวของเป็นไม้ · ลบออกก่อนแทน lookbehind (Safari รุ่นเก่า parse ไม่ผ่านทั้งไฟล์)
    const text = String(t).replace(/ผลไม้|ตัดไม้/g, '');
    const m = text.match(WOOD_EN) ?? text.match(WOOD_TH);
    if (m) return m[0].toUpperCase();
  }
  return null;
}

const whyOf = {
  exact: (hs, chip, src) => `พิกัด ${hs} ต้องขอ ${chip} · ที่มา: ${src}`,
  hs8All: (hs, chip, src) => `พิกัด ${hs} ยังไม่มีรหัสสถิติ แต่ทุกรหัสของพิกัดนี้ที่ระบบรู้ต้องขอ ${chip} · ที่มา: ${src}`,
  hs8Mixed: (hs, chip, rule) => `พิกัด ${hs} ยังไม่มีรหัสสถิติ และ ${rule} ต้องขอ ${chip} ฝากช่วยเช็คกับชิปปิ้ง`,
  otherStat: (hs, chip, rule) => `พิกัด ${hs} ต่างจาก ${rule} ที่ต้องขอ ${chip} แค่รหัสสถิติ ฝากช่วยเช็คกับชิปปิ้ง`,
};

const SOURCE_DEFAULT = 'กฎพิกัดในระบบ';
const RANK = { must: 2, check: 1 };

// card = ใบข้อมูลสินค้า (null = ยังไม่มีใบ) · desc = ชื่อบนไฟล์ invoice ใช้เมื่อยังไม่มีใบ
// คืน { level: must|check|unknown|quiet, flags: [...เรียงตามหน่วยงาน], reason, hs, hsRaw }
export function checkCard(card, index, desc = null) {
  const out = new Map();
  const add = (agency, level, why, extra = {}) => {
    const cur = out.get(agency);
    if (cur && RANK[cur.level] > RANK[level]) return;
    if (cur && cur.level === level) {
      if (!cur.whys.includes(why)) cur.whys.push(why);
      for (const k of Object.keys(extra)) if (cur[k] == null) cur[k] = extra[k];
      return;
    }
    out.set(agency, { agency, level, whys: [why], ...extra });
  };
  const addMeasures = (rule, levelOf, hsLabel, why) => {
    for (const m of measureList(rule)) {
      for (const a of measureAgencies(m)) {
        const chip = PERMIT_AGENCY[a].chip;
        const level = typeof levelOf === 'function' ? levelOf(a) : levelOf;
        add(a, level, why(chip, m.source || SOURCE_DEFAULT, level), {
          hs: hsLabel, ruleHs: rule.hs_code, source: m.source || SOURCE_DEFAULT, side: m.side ?? null,
          neededBy: m.needed_by ?? null, remindBefore: m.remind_before ?? null, note: m.note ?? null,
        });
      }
    }
  };

  const hsRaw = card?.hs_code ?? null;
  const d = hsDigits(hsRaw);
  const hs = d ? formatHs(d) : null;
  let reason = null;

  if (!card) reason = 'nocard';
  else if (!d) reason = 'nohs';
  else if (d.length === 11) {
    const rule = index.by11.get(d);
    if (rule && measureList(rule).length) {
      addMeasures(rule, 'must', hs, (chip, src) => whyOf.exact(hs, chip, src));
    } else {
      const flagged = (index.by8.get(d.slice(0, 8)) ?? []).filter(r => measureList(r).length);
      for (const r of flagged) addMeasures(r, 'check', hs, (chip) => whyOf.otherStat(hs, chip, r.hs_code));
      if (!rule && !flagged.length) reason = 'norule';
    }
  } else if (d.length === 8) {
    const kids = index.by8.get(d) ?? [];
    const flagged = kids.filter(r => measureList(r).length);
    if (!kids.length) reason = 'norule';
    else if (flagged.length === kids.length) {
      // ทุกรหัสสถิติมีมาตรการ แต่คนละหน่วยงาน: ต้องขอเฉพาะหน่วยงานที่ติดครบทุกรหัส ที่เหลือฝากเช็ค
      const inAll = (a) => kids.every(r => measureList(r).some(m => measureAgencies(m).includes(a)));
      for (const r of flagged) {
        addMeasures(r, a => (inAll(a) ? 'must' : 'check'), hs, (chip, src, level) => (level === 'must' ? whyOf.hs8All(hs, chip, src) : whyOf.hs8Mixed(hs, chip, r.hs_code)));
      }
    } else {
      for (const r of flagged) addMeasures(r, 'check', hs, (chip) => whyOf.hs8Mixed(hs, chip, r.hs_code));
    }
  } else reason = 'badhs';

  if (card) {
    const nameEn = card.name_en ?? '';
    if (NOTE_DOA.test(nameEn)) add('doa', 'must', `ทะเบียนเดิมจดไว้ที่รุ่นนี้ว่า "${nameEn.match(NOTE_DOA)[0].replace(/\*+\s*/, '')}"`, { hs });
    if (NOTE_TISI.test(nameEn)) add('tisi', 'must', 'ทะเบียนเดิมจดไว้ที่รุ่นนี้ว่า "ติด สมอ"', { hs });
    if (NOTE_HS_TISI.test(hsRaw ?? '')) add('tisi', 'must', `ในช่องพิกัดของรุ่นนี้จดไว้ว่า "${hsRaw}"`, { hs });
    const hit = d.length === 11 ? CHECK_HS[d]
      : d.length === 8 ? Object.entries(CHECK_HS).find(([k]) => k.startsWith(d))?.[1] : null;
    if (hit) add(hit.agency, 'check', `${hit.why} ฝากช่วยเช็คกับชิปปิ้ง`, { hs });
    const skuHit = CHECK_SKU[skuKey(card.sku)];
    if (skuHit) add(skuHit.agency, 'check', `${skuHit.why} ฝากช่วยเช็คกับชิปปิ้ง`, { hs });
  }

  // ไม่มีใบ/ไม่มีพิกัดก็ยังอ่านชื่อได้ — เตือนเรื่องไม้ดีกว่าเงียบ
  const word = woodWord(card?.name_en, card?.name_th, card?.material, card?.what_is_it, card ? null : desc);
  if (word) add('doa', 'check', `ชื่อหรือวัสดุมีคำว่า "${word}" ฝากช่วยเช็คเรื่องเอกสารกรมวิชาการเกษตรกับชิปปิ้ง`, { hs });

  const flags = [...out.values()].sort((a, b) => PERMIT_AGENCY[a.agency].order - PERMIT_AGENCY[b.agency].order);
  const unconfirmed = !!(card && d && card.hs_confirmed === false);
  const level = flags.some(f => f.level === 'must') ? 'must'
    : flags.length ? 'check'
    : (reason || unconfirmed) ? 'unknown' : 'quiet';
  return { level, flags, reason: reason ?? (unconfirmed ? 'unconfirmed' : null), hs, hsRaw, unconfirmed };
}

// ตัวอักษรบนป้ายของแถว: must = ชื่อหน่วยงาน · check = "ฝากเช็ค ..." · ไม่รู้ = "ยังบอกไม่ได้"
export const flagChip = (f) => (f.level === 'must' ? PERMIT_AGENCY[f.agency].chip : `ฝากเช็ค ${PERMIT_AGENCY[f.agency].chip}`);

export const UNKNOWN_TEXT = {
  nocard: 'ยังไม่มีใบข้อมูลสินค้า จึงยังไม่รู้พิกัด — สร้างใบและใส่พิกัดแล้ว ระบบจะเช็คให้ที่หน้าใบข้อมูลสินค้า',
  nohs: 'รุ่นนี้ยังไม่มีพิกัด — ใส่พิกัดแล้ว ระบบจะเช็คให้ที่หน้าใบข้อมูลสินค้า',
  norule: 'พิกัดนี้ยังไม่มีข้อมูลในระบบ ฝากช่วยถามชิปปิ้ง',
  badhs: 'ช่องพิกัดอ่านไม่ออก ฝากช่วยตรวจว่าใส่ครบ 8 หรือ 11 หลัก',
  unconfirmed: 'พิกัดนี้ยังรอยืนยัน ระบบจึงยังบอกไม่ได้ ฝากช่วยถามชิปปิ้ง',
};

// lines = [{ key, sku, name, cardId, result }] → กล่องสรุป: แยกหน่วยงาน > ระดับ > พิกัด
const WHEN_ORDER = ['before_pay', 'before_ship', 'before_pickup', 'before_clear', 'on_arrival'];
// กำหนดที่เร็วกว่า — ไม่ให้คำแนะนำขึ้นกับว่าบรรทัดไหนมาก่อนในไฟล์
const earlier = (a, b) => {
  if (!a || !b) return a ?? b ?? null;
  const rank = (v) => { const i = WHEN_ORDER.indexOf(v); return i < 0 ? Infinity : i; };   // ค่าที่พิมพ์ผิดในกฎต้องไม่ชนะ
  return rank(a) <= rank(b) ? a : b;
};

export function summarizePermits(lines) {
  const agencies = new Map();
  const unknown = { nocard: [], nohs: [], norule: [], badhs: [], unconfirmed: [] };
  const quiet = [];
  // checkLines = บรรทัดที่มีป้ายฝากเช็ค (รวมบรรทัดที่ต้องขอหน่วยงานอื่นอยู่แล้ว) — ใช้ตัวเลขนี้ทั้งกล่องและป้ายหัวหน้า ให้ตรงกัน
  const counts = { must: 0, check: 0, unknown: 0, quiet: 0, total: 0, checkLines: 0 };
  for (const li of lines) {
    const r = li.result;
    counts.total++;
    counts[r.level]++;
    if (r.flags.some(f => f.level === 'check')) counts.checkLines++;
    if (r.level === 'quiet') quiet.push(li);
    // มีป้ายฝากเช็คแต่ยังไม่รู้พิกัด: ตรวจได้แค่คำบอกว่าเป็นไม้ เรื่อง สมอ. ยังไม่ได้ตรวจ จึงต้องนับด้วย
    if (r.reason && !(r.level === 'must' && r.reason === 'unconfirmed')) unknown[r.reason]?.push(li);
    for (const f of r.flags) {
      if (!agencies.has(f.agency)) agencies.set(f.agency, { agency: f.agency, meta: PERMIT_AGENCY[f.agency], must: 0, check: 0, groups: new Map(), side: null, neededBy: null, remindBefore: null });
      const a = agencies.get(f.agency);
      a[f.level]++;
      const key = `${f.level}|${f.hs ?? ''}`;
      if (!a.groups.has(key)) a.groups.set(key, { key, level: f.level, hs: f.hs ?? null, lines: [], flag: f, whys: [] });
      const g = a.groups.get(key);
      g.lines.push(li);
      for (const w of f.whys) if (!g.whys.includes(w)) g.whys.push(w);
      if (f.level === 'must') {
        a.side = a.side ?? f.side ?? null;
        a.neededBy = earlier(a.neededBy, f.neededBy);
        a.remindBefore = earlier(a.remindBefore, f.remindBefore);
      }
    }
  }
  const list = [...agencies.values()]
    .map(a => ({ ...a, groups: [...a.groups.values()].sort((x, y) => RANK[y.level] - RANK[x.level] || y.lines.length - x.lines.length) }))
    .sort((a, b) => a.meta.order - b.meta.order);
  const unknownLines = [...unknown.nocard, ...unknown.nohs, ...unknown.norule, ...unknown.badhs, ...unknown.unconfirmed];
  return { counts, agencies: list, unknown, unknownLines, quiet };
}

// หน่วยงานที่แนะนำเป็นค่าตั้งต้นของหน้าเอกสารยื่น (AGENCIES ใน PermitSheet: tisi | doa | other)
export function sheetAgency(result) {
  const f = result?.flags?.find(x => x.level === 'must') ?? result?.flags?.[0];
  if (!f) return null;
  return f.agency === 'tisi' || f.agency === 'doa' ? f.agency : 'other';
}

const WHEN_TH = {
  before_pay: 'ก่อนจ่ายเงิน', before_ship: 'ก่อนของออกจากต้นทาง', before_pickup: 'ก่อนรับของ',
  before_clear: 'ก่อนเดินพิธีศุลกากร', on_arrival: 'ตอนของถึง',
};

// "ใครทำ · ต้องได้เมื่อไร · ควรเริ่มเมื่อไร" ของหน่วยงานนี้ในกล่องสรุป
export function agencyWhen(a) {
  const parts = [];
  // มีหลักฐานว่าเรายื่นเองเฉพาะ สมอ. (บันทึกบทเรียน SP-261015) · เกษตรมีทั้ง Phyto ต้นทางและ พ.ก.5 ฝั่งไทย ดูคำแนะนำของหน่วยงาน
  if (a.agency === 'tisi') parts.push('เรายื่นในไทย');
  else if (a.agency !== 'doa' && a.side === 'import') parts.push('ฝั่งไทย ฝากถามชิปปิ้งว่าใครยื่น');
  else if (a.agency !== 'doa' && a.side === 'export') parts.push('ซัพพลายเออร์เตรียมที่ต้นทาง');
  if (WHEN_TH[a.neededBy]) parts.push(`ขอให้ได้เอกสาร${WHEN_TH[a.neededBy]}`);
  if (WHEN_TH[a.remindBefore]) parts.push(`ควรเริ่ม${WHEN_TH[a.remindBefore]}`);
  return parts.join(' · ');
}

// การ์ดเอกสารในตู้ของหน่วยงานนี้ → สถานะที่บอกคนได้ (import_license_other ใช้ร่วมหลายหน่วยงาน แยกด้วยฝั่ง)
//   compute_requirements จับคู่พิกัดแบบตรงตัว + รันเฉพาะตอนแก้รายการ ⇒ "ยังไม่มีการ์ด" เกิดได้จริง กล่องนี้จึงคำนวณสดแยกจากการ์ด
//   ⚠ ไม่มีคำว่า "ครบ": ช่องเดียวต่อ (ตู้ · ใบ · ชนิด · ฝั่ง) แต่หลายรุ่น/หลายหน่วยงานใช้ร่วมกัน ไฟล์เดียวไม่ได้แปลว่าครอบทุกรายการ
//     ใบเสร็จ สมอ. จริงระบุรายบรรทัดของ invoice (tisi_permitnumber: เฉพาะบรรทัด 26-28)
export function agencyCardState(agency, reqs, { shared = false } = {}) {
  const types = AGENCY_REQ_TYPES[agency] ?? [];
  const side = agency === 'origin' ? 'export' : 'import';
  const hit = (reqs ?? []).filter(r => types.includes(r.req_type)
    && (r.req_type !== 'import_license_other' || r.side === side));
  if (!hit.length) return { key: 'none', text: 'ยังไม่มีช่องแนบในตู้' };
  if (hit.some(r => r.required !== false && r.status === 'flagged')) return { key: 'flagged', text: 'การ์ดในตู้: มีไฟล์ ฝากช่วยตรวจอีกครั้ง' };
  if (hit.some(r => r.required !== false && r.status === 'missing')) return { key: 'missing', text: 'การ์ดในตู้: ยังไม่มีไฟล์' };
  if (hit.some(r => r.status === 'received' || r.status === 'verified')) {
    const text = shared ? 'การ์ดในตู้: มีไฟล์แล้ว แต่ใช้ช่องเดียวกับหน่วยงานอื่น ฝากเช็คว่าครบทุกหน่วยงาน'
      : agency === 'doa' ? 'การ์ดในตู้: มีไฟล์แล้ว ฝากเช็คว่าครอบทุกรายการ และต้องใช้ พ.ก.5 ด้วยไหม'
      : 'การ์ดในตู้: มีไฟล์แล้ว ฝากเช็คว่าครอบทุกรายการ';
    return { key: 'filed', text };
  }
  return { key: 'na', text: shared ? 'การ์ดในตู้: บันทึกว่ารอบนี้ไม่ใช้ แต่ใช้ช่องเดียวกับหน่วยงานอื่น ฝากเช็คว่าครบทุกหน่วยงาน' : 'การ์ดในตู้: บันทึกว่ารอบนี้ไม่ใช้' };
}

// ป้ายหัวหน้าใบข้อมูลสินค้า — ⚠ ห้ามมีคำว่า "ครบ": ไฟล์เดียวในช่องไม่ได้พิสูจน์ว่าครอบทุกรุ่น
export function permitPill(summary, reqs, { closed = false } = {}) {
  if (!summary) return { cls: 'none', text: 'ใบอนุญาต: ตรวจไม่ได้' };
  if (closed) return { cls: 'none', text: 'ใบอนุญาต: ตู้ปิดงานแล้ว' };
  const asked = summary.agencies.filter(a => a.must > 0);
  const state = (a) => (reqs ? agencyCardState(a.agency, reqs).key : 'none');
  const open = asked.filter(a => !['filed', 'na'].includes(state(a)));
  const chk = summary.counts.checkLines;
  const unk = summary.unknownLines.length;
  const rest = [chk && `ฝากเช็ค ${chk}`, unk && `ยังบอกไม่ได้ ${unk}`].filter(Boolean).join(' · ');
  const tail = rest ? ` · ${rest}` : '';
  if (open.length) return { cls: 'pm', text: `ใบอนุญาต: ต้องขอ ${open.map(a => a.meta.chip).join(' · ')}${tail}` };
  // การ์ดค้างจากรายการที่ถูกลบ/แก้พิกัดไปแล้ว (compute ไม่ลบการ์ด) — กล่องไม่เห็น แต่ Console ยังนับว่าขาด
  if ((reqs ?? []).some(r => r.required !== false && ['missing', 'flagged'].includes(r.status))) {
    return { cls: 'pm', text: `ใบอนุญาต: มีการ์ดเอกสารค้างในตู้ ฝากช่วยเช็ค${tail}` };
  }
  if (asked.some(a => state(a) === 'filed')) return { cls: 'pm', text: `ใบอนุญาต: มีไฟล์แล้ว ฝากเช็คว่าครอบทุกรายการ${tail}` };
  if (asked.length) return { cls: rest ? 'pm' : 'none', text: `ใบอนุญาต: บันทึกว่ารอบนี้ไม่ใช้${tail}` };
  if (chk) return { cls: 'pm', text: `ใบอนุญาต: ${rest}` };
  if (unk) return { cls: 'none', text: `ใบอนุญาต: ${rest}` };
  return { cls: 'none', text: 'ใบอนุญาต: ไม่พบในระบบ' };
}

// ข้อความสั้นต่อท้ายผลนำเข้า: "สมอ. 5 · เกษตร 2"
export function mustLine(summary) {
  return summary.agencies.filter(a => a.must > 0).map(a => `${a.meta.chip} ${a.must}`).join(' · ');
}
